<template>
  <div>
    <div class="rules-cell-left flex-hl-vc flex-hw">
      <!-- 权益 -->
      <template v-if="service.benefit?.benefits?.[0]?.benefitDetails">
        <div v-for="benefit in service.benefit.benefits[0].benefitDetails"
          :class="{ 'benefit-item': true, 'disabled': benefit.disabled, 'more': !!benefit.text }"
          :key="benefit.code">
          <template v-if="!benefit.disabled">
            <template v-if="benefit.template || benefit.compoment">
              <a-tooltip>
                <template v-slot:title>
                  <div v-html="benefit.template || benefit.compoment"></div>
                </template>
                <l8-icon :class="['benefit-icon', benefit.icon]" :type="benefit.icon"></l8-icon>
                <span class="value" :style="isRed(benefit.code) ? { color: 'red' } : {}">{{ benefit.name }}</span>
              </a-tooltip>
            </template>
            <template v-else>
              <!-- 临时模板 -->
              <template v-if="['FREE_LUGGUE','CARRY_LUGGUE'].includes(benefit.code)">
                  <a-popover overlayClassName="change-popover" :overlayStyle="{
                    width: '666px'
                  }" placement="bottom" @visibleChange="visible => onShowOtherRules(visible)">
                    <template slot="content">
                      <div class="cell-header">行李额说明</div>
                      <div class="cell-body" v-if="isOtherRulesReady">
                        <benefit-luggage :list="service.benefit?.benefits?.[0]?.luggageBenefitDetails"></benefit-luggage>
                      </div>
                    </template>
                    <l8-icon :class="['benefit-icon', benefit.icon]" :type="benefit.icon"></l8-icon>
                    <span class="value" :style="isRed(benefit.code) ? { color: 'red' } : {}">{{ benefit.name }}</span>
                  </a-popover>
              </template>
              <a-tooltip v-else>
                <template v-slot:title>
                  <div v-html="benefit.text"></div>
                </template>
                <l8-icon :class="['benefit-icon', benefit.icon]" :type="benefit.icon"></l8-icon>
                <span class="value" :style="isRed(benefit.code) ? { color: 'red' } : {}">{{ benefit.name }}</span>
              </a-tooltip>
            </template>
          </template>
          <template v-else>
            <l8-icon :class="['benefit-icon', benefit.icon]" :type="benefit.icon"></l8-icon>
            <span class="value" :style="isRed(benefit.code) ? { color: 'red' } : {}">{{ benefit.name }}</span>
          </template>
        </div>
      </template>
      <template v-else>-</template>
      <!-- 退改规则 -->
      <template v-if="(service?.refundChangeFees?.length > 0 || service?.refundChangeFeesInt?.cnRule)">
        <div class="benefit-item changes rule-refunds hover-effect"
          >
          <a-popover overlayClassName="change-popover" :overlayStyle="{
            width: '666px'
          }" placement="bottom" @visibleChange="visible => onChangesVisibleChange(visible)">
            <template slot="content">
              <div class="cell-header">退改签规则</div>
              <div class="cell-body">
                <div class="detail">
                  <template v-if="!ifInternational?.()">
                    <table v-if="isRulesReady">
                      <colgroup>
                        <col style="width: 72px;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th>时限</th>
                          <th v-for="(change, changeIndex) in service.refundChangeFees[0].change"
                            :key="'th' + change.takeoffFrom">
                            <template v-if="changeIndex === 0">离站时间前{{ -change.takeoffFrom }}小时( 不含 )以内至航班起飞后</template>
                            <template v-else-if="changeIndex === (service.refundChangeFees[0].change.length - 1)">离站时间前{{
                                -change.takeoffTo
                            }}小时( 含 )以外</template>
                            <template v-else>离站时间前{{ -change.takeoffTo }}小时( 含 )至{{ -change.takeoffFrom }}小时( 不含
                              )以内</template>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>变更费（每次）</td>
                          <td v-for="change in service.refundChangeFees[0].change" :key="change.takeoffFrom">
                            {{ (change.changeRefundDesc || change.amount) | ruleFee('免收变更费（每次）') }}
                          </td>
                        </tr>
                        <tr>
                          <td>退票费</td>
                          <td v-for="refund in service.refundChangeFees[0].refund" :key="refund.takeoffFrom">
                            {{ (refund.changeRefundDesc || refund.amount) | ruleFee('免收退票费') }}
                          </td>
                        </tr>
                        <tr>
                          <td>签转</td>
                          <td v-for="signed in service.refundChangeFees[0].signed" :key="signed.takeoffFrom">
                            {{ signed.canTran ? '允许' : '不允许' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <a-spin v-else></a-spin>
                  </template>
                  <template v-else>
                    <div class="refund-changes-detail-int" v-if="service.refundChangeFeesInt?.cnRule" v-html="getRefundChangeFeesInt(service)"></div>
                    <a-spin v-else></a-spin>
                  </template>
                </div>
                <!-- <div v-if="!ifInternational?.()">
                  <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 以上退改签费用标准仅供参考，请以实际情况为准。<br/>
                  <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 客票变更时，需同时收取票价价差和变更手续费。
                </div>
                <div v-else>
                  <span class="primary-color">1.如您购买往返客票，退改费将按照去回程中更严格一方的标准收取，具体请以实际审核退改金额为准。</span><br/>
                  2.因汇率等时有变动，以上手续费仅供参考，具体可退税费需人工核实，以实际审核退改金额为准。<br>
                  <span class="primary-color">另: 儿童变更/退票手续费按照成人相应规定执行。 不占座婴儿变更/退票免收手续费。</span><br/>
                </div> -->
                <refund-rules-detail :ifInternational="ifInternational?.()"></refund-rules-detail>
              </div>
            </template>
            <span><l8-icon type="icon-base-guize"></l8-icon>退改签规则</span>
          </a-popover>
        </div>
      </template>
      <template v-else>-</template>

    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import benefitLuggage from '@/components/benefits/luggage'
import refundRulesDetail from '@/components/benefits/refund-rules-detail'
import getAppInfo from '@/utils/from'

export default {
  props: {
    service: {
      type: Object
    },
    isJJC: {
      type: Boolean
    }
  },
  components: {
    benefitLuggage,
    refundRulesDetail
  },
  data () {
    return {
      isRulesReady: false,
      isOtherRulesReady: false,
      appInfo: getAppInfo()
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  methods: {
    isRed (code) {
      return this.appInfo.airline === '8L' && (code.includes('MEAL') || code.includes('FOOD') || code.includes('LUGGUE'))
    },
    onChangesVisibleChange (visible) {
      if (visible) {
        this.isRulesReady = true
        window.__MICRO_ROOT__?.api?.track?.('reserve_OTA_reschedule')
      }
    },
    onShowOtherRules (visible) {
      if (visible) {
        this.isOtherRulesReady = true
      }
    },
    getLuggageBenefitName (obj) {
      return get(obj, 'benefit.benefits[0].languageBenefitDetails[0].checkinBenefit.name')
    },
    getRefundChangeFeesInt (service) {
      return service.refundChangeFeesInt?.cnRule?.replaceAll('\n', '<br>')
    }
  }
}
</script>
